import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import InfoTooltip from '../InfoTooltip/InfoTooltip'
import styles from './SettingNameCell.module.scss'

export default function SettingNameCell({ labelId, sourceKey, tooltipElementId, tooltipMessageId }) {
  return (
    <span className={styles.content}>
      <InfoTooltip id={tooltipElementId} messageId={tooltipMessageId}>
        <span className={styles.label}>
          <FormattedMessage id={labelId} />
        </span>
      </InfoTooltip>
      <code className={styles.sourceKey}>{sourceKey}</code>
    </span>
  )
}

SettingNameCell.propTypes = {
  labelId: PropTypes.string.isRequired,
  sourceKey: PropTypes.string.isRequired,
  tooltipElementId: PropTypes.string.isRequired,
  tooltipMessageId: PropTypes.string.isRequired,
}
